import { faTrash } from "@fortawesome/pro-solid-svg-icons";
import { BoxControl, ButtonControl, CheckboxControl, DividerControl, IconButtonControl, IncrementControl, LabelControl, LinkButtonControl, } from "doshx_controls_web";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { cancel_basket } from "../../../api/calls/basket/cancel_basket";
import { remove_products } from "../../../api/calls/basket/remove_products";
import { update_quantity } from "../../../api/calls/basket/update_quantity";
import { setBasket } from "../../../reducers/slices/basket/basket";
import { get_basket_thunk } from "../../../reducers/slices/basket/thunks/get_basket_thunk";
import { calculate_basket_thunk } from "../../../reducers/slices/basket/thunks/calculate_basket_thunk";
import { setMainModal } from "../../../reducers/slices/main";
import { formatPrice } from "../../../helpers/formatPrice";
export const PopulatedBasket = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { basket } = useSelector((state) => state.basketState);
    const [test, setTest] = useState(0);
    const [selectedProducts, setSelectedProducts] = useState([]);
    return (React.createElement("div", { className: "flex flex-col lg:flex-row gap-x-4 gap-y-8" },
        React.createElement("div", { className: "flex-grow flex flex-col gap-4" },
            React.createElement(BoxControl, { className: "flex flex-row justify-between items-center", borderColor: "border-secondary" },
                React.createElement(CheckboxControl, { label: "Select all", uncheckedColor: "text-borders-dark", checkedColor: "text-primary", value: selectedProducts.length === basket?.product_list.length, onChange: (v) => {
                        if (v) {
                            for (let p of basket.product_list) {
                                if (!selectedProducts.includes(p._id)) {
                                    selectedProducts.push(p._id);
                                }
                            }
                            setSelectedProducts([...selectedProducts]);
                        }
                        else {
                            setSelectedProducts([]);
                        }
                    } }),
                React.createElement("div", { className: "flex flex-row flex-wrap gap-8" },
                    React.createElement(LinkButtonControl, { label: "CANCEL BASKET", textColor: "text-red-500", onClick: () => {
                            cancel_basket({
                                _id: basket._id,
                            }).then((response) => {
                                if (response.success) {
                                    dispatch(setBasket(null));
                                    navigate("/shop");
                                }
                                else {
                                    dispatch(setMainModal({
                                        title: "Something went wrong!",
                                        messages: [response.message],
                                    }));
                                }
                            });
                        } }),
                    React.createElement(LinkButtonControl, { label: "REMOVE SELECTED", textColor: "text-red-500", onClick: () => {
                            if (selectedProducts && selectedProducts.length) {
                                remove_products({
                                    _id: basket._id,
                                    product_id_list: selectedProducts,
                                }).then((response) => {
                                    if (response.success) {
                                        dispatch(get_basket_thunk());
                                    }
                                    else {
                                        dispatch(setMainModal({
                                            title: "Something went wrong!",
                                            messages: [response.message],
                                        }));
                                    }
                                });
                            }
                            else {
                                dispatch(setMainModal({
                                    title: "Selection required.",
                                    messages: ["Please make a selection!"],
                                }));
                            }
                        } }))),
            React.createElement("div", { className: "flex flex-col pl-4" }, basket &&
                basket.product_list.map((product, index) => {
                    // // console.log();
                    return (React.createElement("div", { key: `container-${product._id}` },
                        React.createElement("div", { className: "flex flex-none flex-row" },
                            React.createElement(CheckboxControl, { checkedColor: "text-primary", uncheckedColor: "text-borders-dark", value: selectedProducts.includes(product._id), onChange: () => {
                                    let idx = selectedProducts.indexOf(product._id);
                                    if (selectedProducts.includes(product._id)) {
                                        selectedProducts.splice(idx, 1);
                                        setSelectedProducts([...selectedProducts]);
                                    }
                                    else {
                                        selectedProducts.push(product._id);
                                        setSelectedProducts([...selectedProducts]);
                                    }
                                    dispatch(setBasket({ ...basket }));
                                } }),
                            React.createElement("div", { className: "flex-grow flex flex-row" },
                                React.createElement("div", { className: "w-[80px] h-[80px]" },
                                    React.createElement("img", { className: "w-full h-full object-cover rounded-lg", src: product.image_url ?? "" })),
                                React.createElement("div", { className: "flex-1 flex flex-col gap-2" },
                                    React.createElement("div", { className: "flex-1 flex flex-col self-start pl-4" },
                                        React.createElement(LabelControl, { label: product.title, size: "small", textColor: "text-borders-dark" }),
                                        !product.on_promotion ? (React.createElement(LabelControl, { label: formatPrice({
                                                value: product.price?.toString() ?? "0",
                                            }), size: "small", textColor: "text-primary" })) : (React.createElement("div", { className: "flex items-center justify-between" },
                                            React.createElement(LabelControl, { label: formatPrice({
                                                    value: product?.promotion_price ?? "0",
                                                    decimalPlaces: 2,
                                                }), size: "small", textColor: "text-primary" }),
                                            React.createElement("div", { className: "line-through" },
                                                React.createElement(LabelControl, { label: formatPrice({
                                                        value: product?.price ?? "0",
                                                        decimalPlaces: 2,
                                                    }), size: "xsmall" }))))),
                                    React.createElement("div", { className: "flex items-center self-start pl-4 gap-4" }, product.variations &&
                                        product.variations.map((variant, index) => {
                                            // each variant, in a product that exists in the basket, will only have 1 variation
                                            return (React.createElement(BoxControl, { key: index, borderColor: "border-transparent", addPadding: false, backgroundColor: "bg-primary" },
                                                React.createElement("div", { className: "py-1 px-2" },
                                                    React.createElement(LabelControl, { label: `${variant.variations[0].title}`, size: "small", textColor: "text-secondary" }))));
                                        })),
                                    React.createElement("div", { className: "flex items-center self-start pl-4 gap-4" }, product.deal && (React.createElement(BoxControl, { key: 1, borderColor: "border-transparent", addPadding: false, backgroundColor: "bg-primary" },
                                        React.createElement("div", { className: "p-2" },
                                            React.createElement(LabelControl, { label: `${product.deal.deal_name} of R${product.deal.discount} applied to this product.`, size: "small", textColor: "text-secondary" }))))),
                                    React.createElement("div", { className: "flex-grow justify-end self-end flex flex-row items-center gap-4" },
                                        React.createElement(IncrementControl, { borderColor: "border-borders-gray", key: `increment-${product._id}`, size: "small", value: parseInt(product.quantity), max: 10, onChange: (v) => {
                                                // // console.log(v);
                                                update_quantity({
                                                    _id: basket._id,
                                                    product: {
                                                        _id: product._id,
                                                        quantity: v.toString(),
                                                    },
                                                }).then((response) => {
                                                    if (response.success) {
                                                        // getTotal(basket.product_list);
                                                        // // console.log("here");
                                                        dispatch(calculate_basket_thunk(response));
                                                    }
                                                    else {
                                                        dispatch(setMainModal({ title: "Something went wrong!", messages: [response.message] }));
                                                    }
                                                });
                                            } }),
                                        React.createElement(IconButtonControl, { icon: faTrash, backgroundColor: "bg-primary" //"bg-gray-200"
                                            , iconColor: "text-secondary" //"text-gray-500"
                                            , size: "small", onClick: () => {
                                                remove_products({
                                                    _id: basket._id,
                                                    product_id_list: [product._id],
                                                }).then((response) => {
                                                    if (response.success) {
                                                        dispatch(get_basket_thunk());
                                                    }
                                                    else {
                                                        dispatch(setMainModal({ title: "Something went wrong!", messages: [response.message] }));
                                                    }
                                                });
                                            } }))))),
                        index < basket.product_list.length - 1 && React.createElement(DividerControl, null)));
                }))),
        React.createElement("div", { className: "lg:w-96" },
            React.createElement(BoxControl, { className: "flex flex-col gap-4", backgroundColor: "bg-white", borderColor: "border-borders-light", shadowColor: "shadow-shadows-dark/10" },
                React.createElement(LabelControl, { label: "Shopping Summary", size: "large", textColor: "text-borders-dark" }),
                React.createElement("div", { className: "flex flex-row justify-between" },
                    React.createElement(LabelControl, { label: "Discount Total", textColor: "text-borders-dark" }),
                    React.createElement(LabelControl, { label: formatPrice({
                            value: basket?.total_product_deals.toString(),
                            decimalPlaces: 2,
                        }), size: "large", textColor: "text-primary" })),
                React.createElement("div", { className: "flex flex-row justify-between" },
                    React.createElement(LabelControl, { label: "Total", textColor: "text-borders-dark" }),
                    React.createElement(LabelControl, { label: formatPrice({
                            value: basket?.total.toString(),
                            decimalPlaces: 2,
                        }), size: "large", textColor: "text-primary" })),
                React.createElement("div", { className: "flex flex-row justify-between" },
                    React.createElement(LabelControl, { label: "Outstanding Amount", textColor: "text-borders-dark", bold: true }),
                    React.createElement(LabelControl, { label: formatPrice({
                            value: basket?.outstanding_amount.toString(),
                            decimalPlaces: 2,
                        }), size: "large", bold: true, textColor: "text-primary" })),
                React.createElement(ButtonControl, { label: "Checkout", textColor: "text-secondary", backgroundColor: "bg-primary", onClick: () => {
                        navigate("/checkout");
                    } }),
                React.createElement("div", { className: "flex flex-row justify-center" },
                    React.createElement(LinkButtonControl, { label: "Back to Shop", textColor: "text-primary", onClick: () => {
                            navigate("/shop");
                        } }))))));
};
